import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useLoader } from '../../../../../../../../__legacy__/helpers/useLoader';
import { MarkingToolModal } from '../../../commons/MarkingToolModal';
import { AddMarkingToolBl } from '../../AddMarkingTool.bl';
import { IAddMarkingToolStore } from '../../AddMarkingTool.store';
import { ColorFieldContainer } from '../fields/ColorField.container';
import { NameFieldContainer } from '../fields/NameField.container';
import { ToolTypeFieldContainer } from '../fields/ToolTypeField.container';

export const AddMarkingToolModalContainer = observer((): ReactElement => {
  const bl = useInjection(AddMarkingToolBl.$);
  const store = useInjection(IAddMarkingToolStore.$);

  const { withLoaderAsync } = useLoader();

  const handleSubmit = async (): Promise<void> => {
    await withLoaderAsync(bl.addMarkingToolAsync, 'add-or-edit-marking-tool-key');
  };

  const handleHide = (): void => {
    bl.hideModal();
  };

  return (
    <MarkingToolModal
      headerKey='new.projects.details.marking_tools.add.header'
      onHide={handleHide}
      onSubmit={handleSubmit}
      show={store.showModal}
    >
      <NameFieldContainer />
      <ToolTypeFieldContainer />
      <ColorFieldContainer />
    </MarkingToolModal>
  );
});
